module.exports = __webpack_public_path__ + "static/screenshot_07@2x-1fccb80435594caf4ff17d320ffaf1ab.png";